/**
 * Uploads Service
 * Handles all file upload-related API calls
 */

import api from './api';

const uploadsService = {
  /**
   * Upload single image (Admin only - for trips)
   * POST /uploads/image - returns { data: { id, url, filename, ... } }
   */
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return api.apiRequestFormData('/uploads/image', formData, {
      method: 'POST',
      includeAuth: true,
    });
  },

  /**
   * Upload multiple images (Admin only - for trip galleries)
   * POST /uploads/images - expects images[] (Rails params[:images])
   * Response: { uploaded: [{ url, id, filename }, ...] }
   */
  uploadImages: async (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('images[]', file));
    return api.apiRequestFormData('/uploads/images', formData, {
      method: 'POST',
      includeAuth: true,
    });
  },

  /**
   * Delete upload
   */
  deleteUpload: async (id) => api.delete(`/uploads/${id}`),
};

export default uploadsService;
